export default __webpack_public_path__ + "static/media/User.e06d80d5.svg";